export const ThankyouDeleteReason = {
    INAPPROPRIATE: "Inappropriate",
    COMPLAINT: "Complaint",
    CLINICAL_NATURE: "Clinical Nature",
    DUPLICATE_MESSAGE: "Duplicate Message",
    TEST_MESSAGE: "Test Message"
}